import OfficesList from './OfficesList';

export default OfficesList;
